<div *ngIf="projectMsg" class="learning-map-wrap" id="learningWrap-out" (scroll)="elementScroll($event)">
  <div class="project">
    <div class="common-back-btn-blue" id="backBtn"  (click)="goToLearningMap()" style="top:.2rem;z-index:99"></div>
    <div id="stickyBar" *ngIf="isStickey && projectMsg[0].learningPathMetasDetailList.length>0">
      <div class="common-back-btn-blue" id="backBtn"  (click)="goToLearningMap()" style="top:.2rem;z-index:99"></div>
      <!-- 智能陪练tabBar 只有训练营的项目不展示tab-->
      <div class="tabBox" [ngClass]="{'isStickey':isStickey}">
        <div class="tabBar" id="tabBar" >
          <div class="tabItem" id="tabItem-{{i}}" *ngFor="let item of tabList;let i= index;" (click)="checkTab(i,item.type)">
            <span [ngClass]="{'active':i == tabIndex}" [innerHtml]="item.type == 0? '全部': item.type == 1? '课程学习' : item.type == 2? '智能陪练':'作业练习'"></span>
            <span>{{item.totalNum}}</span>
          </div>
          <div id="line" [ngClass]="{'active':tabIndex + 1}" ></div>
        </div>
      </div>
    </div>
    <div class="title">
      <div class="project-title">
        <p class="project-name">{{ projectMsg[0].projectName }}</p>
        <!-- <p class="project-total">共{{ projectMsg[0].totalCourse }}门课程，已学{{ projectMsg[0].totalProgress }}%</p> -->
        <div class="project-video" (click)="openVideo()" *ngIf="isShowVideoBtn">
          <p>项目启动视频</p>
          <img src="{{assetsRoute}}/picture/camp/project_play.png" alt="" class="projectPlay">
        </div>
      </div>
      <!-- <img class="project-img" src="{{assetsRoute}}/picture/camp/camp.png" alt=""> -->
    </div>
    <!-- 进度条 -->
    <div class="study-progress">
      <component-progress-bar [type]="'bar'" [theme]="progressBarTheme" [progress]="totalProgress" [isShowBar]="isShowBar"></component-progress-bar>
    </div>
    <!-- 智能陪练tabBar  只有训练营的项目不展示tab -->
    <div class="tabBox" *ngIf="!isStickey && projectMsg[0].learningPathMetasDetailList.length>0">
      <div class="tabBar" id="tabBar">
        <div class="tabItem" id="tabItem-{{i}}" *ngFor="let item of tabList;let i= index;" (click)="checkTab(i,item.type)">
          <span [ngClass]="{'active':i == tabIndex}" [innerHtml]="item.type == 0? '全部': item.type == 1? '课程学习' : item.type == 2? '智能陪练':'作业练习'"></span>
          <span>{{item.totalNum}}</span>
        </div>
        <div id="line" [ngClass]="{'active':tabIndex + 1}" ></div>
      </div>
    </div>
    <div class="learningWrap">
      <!-- 训练营在含有智能陪练项目中只会出现在全部的tab中 -->
      <ng-container *ngIf="tabIndex == 0 && projectMsg[0].campMetasList">
        <div class="learning-camp" *ngFor="let item of projectMsg[0].campMetasList;let i= index;">
          <p class="name">{{item['name']}}</p>
          <p class="desc">{{item['description']}}</p>
          <div *ngIf="item.isExpiry" class="data-lock">已过期</div>
          <div *ngIf="!item.isExpiry">
            <div *ngIf="item.isOpen" class="button" (click)="goCampList(item['campMetasProjectId'],item['campMetasId'])">点击开启<img style="display:inline-block;width: .15rem;margin-left: .1rem" src="{{assetsRoute}}/picture/camp/i-right-light.png" /></div>
            <div *ngIf="!item.isOpen" class="data-lock">{{ item.campOpenTime }}开放</div>
          </div>
          <div class="img" [ngStyle]="{'background-image': 'url(assets/picture/camp/'+item['campMetasId']+'/camp'+'.png)' }" ></div>
        </div>
      </ng-container>
      <!-- 课程开放提示 -->
      <app-com-tip *ngIf="isShowPrompt" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></app-com-tip>
      <!-- 课程列表 -->
      <div id="learning-Item" [ngClass]="{'learning-Item':true,profeshional:item.profeshional,'overdue':item.homeworkExpiryAtFlag,'comment':!item.homeworkExpiryAtFlag && item.homeworkCommentFlag,'blankData':!item.type}" (click)="item.homeworkDuplicateId ? goHomeWork(item) : goLearnPath(item)" *ngFor="let item of projectMsg[0].learningPathMetasDetailList;let i= index;">
        <div *ngIf="!item.projectLearingToursVo && item.homeworkTitle">
          <div *ngIf="item.abilityVersion === '在线课' || item.abilityVersion === '微课'" class="pinpoint-course-image" [ngClass]="{disabled: item.projectLearingToursVo.lock || item.isUserTicketExpiry}" [ngStyle]="{'background-image': 'url(' + setPinpointPicture(item.id || item.courseId) + '.jpg)'}"></div>
          <div class="img" *ngIf="item.abilityVersion === '酷领导'" [ngStyle]="{'background-image':'url(assets/picture/learningmap/newicon/scorm-' + { '卓越辅导': 1, '超效沟通': 2, '巅峰绩效对话': 3, '活化变革': 4, '建立超卓团队': 5, '开启领导力之门': 6, '任务规划与执行': 7, '效率决策': 8, '致胜表达': 9}[item.series] +'.png)' }" ></div>
          <div class="img" *ngIf="item.abilityVersion !== '在线课' && item.abilityVersion !== '微课' && item.abilityVersion !== '酷领导'" [ngStyle]="{'background-image': item.homeworkOpenAtFlag && !item.homeworkExpiryAtFlag? 'url(assets/picture/learningmap/newicon/' + item.learningPathMetaId + '.png)':'url(assets/picture/learningmap/newicon/disabled/' + item.learningPathMetaId + '.png)' }" ></div>
          <div class="item-work-title">
            <img *ngIf="item.homeworkOpenAtFlag && !item.homeworkExpiryAtFlag" src="{{assetsRoute}}/picture/learningmap/newicon/flag.png" alt="">
            <img *ngIf="!item.homeworkOpenAtFlag || item.homeworkExpiryAtFlag" src="{{assetsRoute}}/picture/learningmap/newicon/disabled/flag.png" alt="">
           {{item.homeworkTitle.indexOf("-")!= -1 ? item.homeworkTitle.split("-")[0] : item.homeworkTitle}}
            </div>
          <div class="work-description" *ngIf="item.abilityVersion === '酷领导'">课程系列：{{item.series}}</div>
          <div class="work-description" *ngIf="item.abilityVersion !== '酷领导'">考察能力：{{item.homeworkLearningPathMetaName}}</div>
          <div class="item-date">结束时间：{{tansFromTimestamp(item.homeworkCloseAt,2)}}</div>
          <!-- 学习进度展示圈 -->
          <div *ngIf="!item.isUserTicketExpiry && (item.homeworkOpenAtFlag || item.homeworkExpiryAtFlag)">
            <component-progress-bar [isPC]="isPC" [redDot]="item.homeworkToastFlag" [theme]="circleTheme" [type]="'circle'" [progress]="item.homeworkProgress" ></component-progress-bar>
          </div>
          <!-- 根据日期锁定课程 -->
          <div *ngIf="item.isUserTicketExpiry || (!item.homeworkOpenAtFlag && !item.homeworkExpiryAtFlag)">
            <div class="card-lock"></div>
          </div>
          <!--      <div class="finishBtn" *ngIf="item.finished || (item.id == 22 && finishSpecialFlag)">已完成</div>-->
          <div *ngIf="!item.isUserTicketExpiry && (item.homeworkOpenAtFlag || item.homeworkExpiryAtFlag)" class="arrow">&gt;</div>
        </div>

        <div *ngIf="item.projectLearingToursVo">
          <div *ngIf="item.abilityVersion === '在线课' || item.abilityVersion === '微课'" class="pinpoint-course-image" [ngClass]="{disabled: item.projectLearingToursVo.lock || item.isUserTicketExpiry}" [ngStyle]="{'background-image': 'url(' + setPinpointPicture(item.id || item.courseId) + '.jpg)'}"></div>
          <div class="img" *ngIf="item.abilityVersion === '酷领导'" [ngStyle]="{'background-image': item.projectLearingToursVo.lock || item.isUserTicketExpiry ? 'url(assets/picture/learningmap/newicon/disabled/scorm-' + { '卓越辅导': 1, '超效沟通': 2, '巅峰绩效对话': 3, '活化变革': 4, '建立超卓团队': 5, '开启领导力之门': 6, '任务规划与执行': 7, '效率决策': 8, '致胜表达': 9}[item.series] +'.png)' : 'url(assets/picture/learningmap/newicon/scorm-' + { '卓越辅导': 1, '超效沟通': 2, '巅峰绩效对话': 3, '活化变革': 4, '建立超卓团队': 5, '开启领导力之门': 6, '任务规划与执行': 7, '效率决策': 8, '致胜表达': 9}[item.series] +'.png)' }" ></div>
          <div class="img" *ngIf="item.abilityVersion !== '在线课' && item.abilityVersion !== '微课' && item.abilityVersion !== '酷领导'" [ngStyle]="{'background-image': item.projectLearingToursVo.lock || item.isUserTicketExpiry? 'url(assets/picture/learningmap/newicon/disabled/' + item.learningPathMetaId + '.png)':'url(assets/picture/learningmap/newicon/' + item.learningPathMetaId + '.png)' }" ></div>
          <div class="item-title"  *ngIf="item.abilityVersion !== '智能陪练'"><span class="version-tag" *ngIf="item.abilityVersion === '英跃微课'">视频课程</span>{{item.name}}</div>
          <div class="item-work-title" *ngIf="item.abilityVersion === '智能陪练'">
            <img *ngIf="item.abilityVersion === '智能陪练' && (!item.projectLearingToursVo.lock || item.isUserTicketExpiry)" src="{{assetsRoute}}/picture/learningmap/newicon/AItraining.png" alt="">
            <img *ngIf="item.abilityVersion === '智能陪练' && item.projectLearingToursVo.lock && !item.isUserTicketExpiry" src="{{assetsRoute}}/picture/learningmap/newicon/disabled/AItraining.png" alt="">
            {{item.name}}
            </div>
          <div class="work-description" *ngIf="item.abilityVersion === '酷领导'">课程系列：{{item.series}}</div>
          <div class="work-description" *ngIf="item.abilityVersion !== '酷领导'">{{item.description}}</div>
          <div class="item-date">预计时间：{{courseDuration[item.learningPathMetaId] ? courseDuration[item.learningPathMetaId] : item.totalHours + 'min'}}</div>
          <!-- 学习进度展示圈 -->
          <div *ngIf="!item.isUserTicketExpiry && !item.projectLearingToursVo.lock">
            <component-progress-bar [isPC]="isPC" [theme]="circleTheme" [type]="'circle'" [progress]="item.progress" ></component-progress-bar>
          </div>
          <!-- 根据日期锁定课程 -->
          <div *ngIf="item.isUserTicketExpiry || item.projectLearingToursVo.lock">
            <component-datestates-bar [isPC]="isPC" [openTime]="item.projectLearingToursVo.openTime" [courseOverdue]="item.isUserTicketExpiry"></component-datestates-bar>
          </div>
          <!--      <div class="finishBtn" *ngIf="item.finished || (item.id == 22 && finishSpecialFlag)">已完成</div>-->
          <div *ngIf="!item.isUserTicketExpiry && !item.projectLearingToursVo.lock" class="arrow">&gt;</div>
        </div>
      </div>
    </div>

    <!-- 宣讲视频 -->
    <div class="peoject-video" *ngIf="isShowvideoDialog">
      <!-- 视频 -->
      <div id="video" [ngClass]="{'pcVideo':isPC}"></div>
      <!--按钮-->
      <component-btn *ngIf="!isPC" [postData]="postData" [theme]="buttonTheme" (onCommit)="goNext($event)"></component-btn>
    </div>
  </div>
</div>
<!-- 新手引导 -->
<div id="mask" *ngIf="isHaveAITraining && !isFirstAITraining && projectMsg" >
  <div id="guideCon" *ngIf="stepNum == 0">
    <div class="learning-Item" *ngIf="firstAITrainingData && firstAITrainingData.projectLearingToursVo && guideStyle">
      <div class="img" [ngStyle]="{'background-image': firstAITrainingData.projectLearingToursVo.lock || firstAITrainingData.isUserTicketExpiry? 'url(assets/picture/learningmap/newicon/disabled/' + firstAITrainingData.learningPathMetaId + '.png)':'url(assets/picture/learningmap/newicon/' + firstAITrainingData.learningPathMetaId + '.png)' }" ></div>
      <div class="item-title"  *ngIf="firstAITrainingData.abilityVersion !== '智能陪练'">{{firstAITrainingData.name}}</div>
      <div class="item-work-title" *ngIf="firstAITrainingData.abilityVersion === '智能陪练'">
        <img *ngIf="firstAITrainingData.abilityVersion === '智能陪练' && (!firstAITrainingData.projectLearingToursVo.lock || firstAITrainingData.isUserTicketExpiry)" src="{{assetsRoute}}/picture/learningmap/newicon/AItraining.png" alt="">
        <img *ngIf="firstAITrainingData.abilityVersion === '智能陪练' && (firstAITrainingData.projectLearingToursVo.lock && !firstAITrainingData.isUserTicketExpiry)" src="{{assetsRoute}}/picture/learningmap/newicon/disabled/AItraining.png" alt="">
        {{firstAITrainingData.name}}
        </div>
      <div class="work-description">{{firstAITrainingData.description}}</div>
      <div class="item-date">预计时间：{{courseDuration[firstAITrainingData.learningPathMetaId]}}</div>
      <!-- 学习进度展示圈 -->
      <div *ngIf="!firstAITrainingData.projectLearingToursVo.lock">
        <component-progress-bar [isPC]="isPC" [theme]="circleTheme" [type]="'circle'" [progress]="firstAITrainingData.progress" ></component-progress-bar>
      </div>
      <!-- 根据日期锁定课程 -->
      <div *ngIf="firstAITrainingData.projectLearingToursVo.lock">
        <component-datestates-bar [isPC]="isPC" [openTime]="firstAITrainingData.projectLearingToursVo.openTime" [courseOverdue]="firstAITrainingData.isUserTicketExpiry"></component-datestates-bar>
      </div>
      <div *ngIf="!firstAITrainingData.isUserTicketExpiry && !firstAITrainingData.projectLearingToursVo.lock" class="arrow">&gt;</div>
    </div>
  </div>
  <div id="guideCon" class="guideCon" *ngIf="stepNum == 1" [ngClass]="{'guideConStyle':guideStyle}">
    <span>全部</span>
    <span>{{allTotalNum}}</span>
  </div>
  <div id="guideTip" [ngClass]="{'guideTipStyle':guideStyle}">
    <div *ngIf="guideStyle">
      <img src="{{assetsRoute}}/picture/learningmap/newicon/top_arrow.png" alt="" id="arrow">
      <div id="guideTipBox">
        <span [innerHtml]="guideTipCon"></span>
        <button (click)="goNextStep()" [innerHtml]="guideTipBtn"></button>
      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/learning-project/learning-project.component.html